import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectedProjectService {
  private selectedProjectSubject = new BehaviorSubject<number | null>(null);
  selectedProject$ = this.selectedProjectSubject.asObservable();

  constructor() {
    // Initialize from localStorage if available (guarded for SSR)
    if (typeof window !== 'undefined' && window?.localStorage) {
      try {
        const stored = localStorage.getItem('selectedProject');
        if (stored) {
          const n = parseInt(stored, 10);
          if (!isNaN(n)) this.selectedProjectSubject.next(n);
        }
      } catch (e) {
        // ignore storage errors
      }
    }
  }

  setSelectedProject(projectNumber: number): void {
    this.selectedProjectSubject.next(projectNumber);
    if (typeof window !== 'undefined' && window?.localStorage) {
      try { localStorage.setItem('selectedProject', projectNumber.toString()); } catch {}
    }
  }

  getSelectedProject(): number | null {
    // Prefer in-memory value from the BehaviorSubject
    const current = this.selectedProjectSubject.getValue();
    if (current !== null && current !== undefined) return current;

    if (typeof window !== 'undefined' && window?.localStorage) {
      try {
        const stored = localStorage.getItem('selectedProject');
        return stored ? parseInt(stored, 10) : null;
      } catch {
        return null;
      }
    }
    return null;
  }

  clearSelectedProject(): void {
    this.selectedProjectSubject.next(null);
    if (typeof window !== 'undefined' && window?.localStorage) {
      try { localStorage.removeItem('selectedProject'); } catch {}
    }
  }
}